import type { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';
import type { User } from '@adornis/buchungsheld-db/entities/user.js';
import { getPluginForScope } from '@adornis/buchungsheld-db/plugins/plugin.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { filter, switchMap, takeUntil, type Observable } from 'rxjs';

/**
 * @element bh-stammdaten-form
 */
@customElement('bh-stammdaten-form')
export class BHStammdatenForm extends ChemistryLitElement {
  institutionID!: string;
  user!: User;

  stammdaten!: Observable<UserStammdaten>;
  stammdatenController!: GenericFieldFormController<UserStammdaten>;

  override connectedCallback(): void {
    super.connectedCallback();

    this.stammdaten
      .pipe(
        takeUntil(this.disconnected),
        filter(Boolean),
        switchMap(d => d.whenChanging),
      )
      .subscribe(() => this.requestUpdate());
  }

  @state() private readonly _translation = new TranslationController<BHTranslationDictionary>(this);

  override render() {
    if (!this.stammdatenController) return nothing;
    const plugin = getPluginForScope('registration::user-data', this.institutionID);
    return plugin.render(this.stammdatenController, this._translation, this.user);
  }
}
